export default "__VITE_PUBLIC_ASSET__cab9f60e__"